module.exports = __webpack_public_path__ + "img/yuqi_b.fb80663f.png";